import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormField, FormGrid, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { useIsChanged } from 'components/powerFlowShared/hooks/useIsChanged';
import { AdapterTypes } from 'components/shared/announcementPicker/adapters';
import { AnnouncementPicker } from 'components/shared/announcementPicker/announcementPicker';
import { QueuePicker } from 'components/shared/queuePicker';
import styles from './voicemail.module.scss';
const ANNOUNCEMENT_FIELD = 'announcement';
const QUEUE_FIELD = 'queue';
export function VoicemailModal({ node, nodeLabel, triggerClose, replaceNode, }) {
    const { payload } = node;
    const { announcement: { file: savedAnnouncement = null } = {}, queue: savedQueue, } = payload || {};
    const [announcement, setAnnouncement] = useState(savedAnnouncement);
    const [queue, setQueue] = useState(savedQueue);
    const [errors, setErrors] = useState({});
    const isChanged = useIsChanged([savedAnnouncement, announcement], [savedQueue, queue]);
    const validate = useCallback(() => {
        const errors = {};
        if (!announcement) {
            errors[ANNOUNCEMENT_FIELD] = 'Selecting an announcement is required';
        }
        if (!queue) {
            errors[QUEUE_FIELD] = 'Selecting a queue is required';
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }, [queue, announcement, setErrors]);
    const handleSave = useCallback(() => {
        const isValid = validate();
        if (!isValid) {
            return;
        }
        const payload = Object.assign(Object.assign({}, node), { icon: 'i-record-tape', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.VOICEMAIL, overlay: [], payload: {
                announcement: {
                    file: announcement !== null && announcement !== void 0 ? announcement : null,
                    tts: null,
                },
                queue: queue !== null && queue !== void 0 ? queue : null,
                transcription: true,
            }, text: 'Voicemail' });
        replaceNode(payload);
        triggerClose();
    }, [announcement, queue, validate, triggerClose, replaceNode, node]);
    const onAnnouncementSelect = useCallback((announcement) => {
        setAnnouncement(announcement);
    }, [setAnnouncement]);
    const onQueueSelect = useCallback((queue) => {
        if (!queue) {
            return;
        }
        const { id: value, name: label } = queue;
        setQueue({ label, value });
    }, [setQueue]);
    const announcementError = errors[ANNOUNCEMENT_FIELD];
    const queueError = errors[QUEUE_FIELD];
    return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { title: nodeLabel, onClose: triggerClose }), _jsxs(ModalBody, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Record or upload a voicemail asking your customers to leave a message if no agents are available." })), _jsxs(FormGrid, Object.assign({ className: styles.form }, { children: [_jsx(FormField, { children: _jsx(AnnouncementPicker, { adapter: AdapterTypes.Announcement, onSelect: onAnnouncementSelect, selectedAudio: announcement, fieldProps: { meta: { error: announcementError } } }) }), _jsx(FormField, { children: _jsx(QueuePicker, { label: "Select queue", placeholder: "No queue selected", selectedQueue: queue, meta: { error: queueError }, input: {
                                        name: 'queue',
                                        onChange: onQueueSelect,
                                    }, searchable: true }) })] }))] }), _jsx(ModalFoot, { confirmOnClick: handleSave, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: triggerClose })] })));
}
